import { render, staticRenderFns } from "./CategoryTreeSelectModal.vue?vue&type=template&id=4b67bcea"
import script from "./CategoryTreeSelectModal.vue?vue&type=script&lang=ts"
export * from "./CategoryTreeSelectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports